<template>
  <div>
    <c-list
      :data="list.items"
      :columns="cList.columns"
      :total="list.total"
      :page-current="listPageCurrent"
      :search-where="listSearchWhere"
      @selection-change="handleListSelectionChange"
    >
      <c-list-header>
        <c-list-operations>
          <Button type="primary" to="/trees/trees/list/form">
            新增
          </Button>
          <c-bulk-delete
            :selected-items="listSelectedItems"
            @ok="confirmDelete"
          >
          </c-bulk-delete>
        </c-list-operations>
        <c-list-search>
          <Form
            class="c-form c-form--search"
            inline
            @submit.native.prevent="search"
          >
            <Form-item prop="no">
              <Input
                class="c-form__input"
                placeholder="请输入编号"
                v-model="cList.cSearch.where.no.$like"
              />
            </Form-item>
            <Form-item prop="name">
              <Input
                class="c-form__input"
                placeholder="请输入名称"
                v-model="cList.cSearch.where.name.$like"
              />
            </Form-item>
            <Form-item prop="categoryId">
              <c-category-select
                class="c-form__input"
                :alias="alias"
                placeholder="请选择科属"
                v-model="cList.cSearch.where.categoryId.$eq"
                @change="
                  value => {
                    cList.cSearch.where.categoryId.$eq = value;
                  }
                "
              ></c-category-select>
            </Form-item>
            <Form-item>
              <Button type="primary" @click="search">
                查询
              </Button>
            </Form-item>
          </Form>
        </c-list-search>
      </c-list-header>
    </c-list>
    <Modal width="434" footer-hide v-model="cList.cQrCode.modal" title="二维码">
      <div class="b-qrcode-wrap">
        <img
          :src="`${$consts.PublicApiUrl}/trees/qrcodes/${cList.cQrCode.no}`"
        />
        <a
          class="ivu-btn ivu-btn-primary"
          :href="
            `${$consts.PublicApiUrl}/trees/qrcodes/${cList.cQrCode.no}?attachment=1`
          "
        >
          下载
        </a>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import RouteParamsMixin from "@/mixins/route-params";
import ListMixin from "@/mixins/list";
import AllCategoriesListMixin from "@/mixins/all-categories-list";

const module = "trees";

const initWhere = {
  no: {
    $like: ""
  },
  name: {
    $like: ""
  },
  categoryId: {
    $eq: ""
  }
};

@Component({
  mixins: [RouteParamsMixin, ListMixin, AllCategoriesListMixin],
  computed: mapState({
    list: state => state[module].list
  })
})
export default class extends Vue {
  data() {
    const { ListColumnWidth, OrderAction } = this.$consts;

    return {
      cList: {
        columns: [
          {
            type: "selection",
            width: 60
          },
          {
            title: "照片",
            width: 118,
            render: (h, { row }) => {
              return h("c-list-image", {
                props: {
                  key: row.pictureIds[0],
                  src: this.$helpers.getImageUrl({
                    id: row.pictureIds[0],
                    width: 80,
                    height: 80
                  })
                }
              });
            }
          },
          {
            title: "编号",
            key: "no",
            width: 160
          },
          {
            title: "名称",
            key: "name",
            minWidth: ListColumnWidth.Title
          },
          {
            title: "科属",
            width: ListColumnWidth.Category,
            render: (h, { row }) =>
              h("span", this.getCategoryNameById(row.categoryId, true))
          },
          {
            title: "操作",
            key: "action",
            width: 320,
            render: (h, { row }) =>
              h("div", [
                h(
                  "Button",
                  {
                    props: {
                      to: `/${this.alias}/trees/list/form/${row.id}`
                    }
                  },
                  "编辑"
                ),
                h("c-dropdown", {
                  props: {
                    title: "排序",
                    options: OrderAction
                  },
                  on: {
                    click: action => {
                      this.order(row.id, action);
                    }
                  }
                }),
                h("c-dropdown", {
                  props: {
                    title: "更多",
                    options: [
                      {
                        value: "qrCodes",
                        label: "二维码"
                      },
                      {
                        value: "treeAdoptions",
                        label: "认养"
                      },
                      {
                        value: "treeWishes",
                        label: "许愿签"
                      },
                      {
                        value: "treeNursings",
                        label: "巡护"
                      }
                    ]
                  },
                  on: {
                    click: action => {
                      if (action === "qrCodes") {
                        this.cList.cQrCode.no = row.no;
                        this.cList.cQrCode.modal = true;
                      } else {
                        this.$router.push({
                          path: `/trees/trees/list/${action}`,
                          query: {
                            from: "list",
                            listSearchWhere: JSON.stringify({
                              treeId: { $eq: row.id },
                              type: "Tree",
                              status: 1
                            })
                          }
                        });
                      }
                    }
                  }
                }),
                h(
                  "c-delete",
                  {
                    on: {
                      ok: () => {
                        this.confirmDelete(row.id);
                      }
                    }
                  },
                  "删除"
                )
              ])
          }
        ],
        cSearch: {
          where: this.$helpers.deepCopy(initWhere)
        },
        cQrCode: {
          no: "",
          modal: false
        }
      }
    };
  }

  async beforeRouteUpdate(to, from, next) {
    this.initListSearchWhere(initWhere);
    this.getList();
    next();
  }

  async created() {
    this.initListSearchWhere(initWhere);
    this.getList();
  }

  getList() {
    return this.$store.dispatch(`${module}/getList`, {
      query: {
        offset: (this.listPageCurrent - 1) * this.$consts.PageSize,
        limit: this.$consts.PageSize,
        where: this.listSearchWhere || initWhere,
        order: [["order", "DESC"]]
      }
    });
  }

  async confirmDelete(ids) {
    await this.$store.dispatch(`${module}/delete`, { id: ids });
    this.$Message.success("删除成功");

    const { items } = await this.getList();
    !items.length && this.goListPrevPage();
  }

  async order(id, action) {
    await this.$store.dispatch(`${module}/postAction`, {
      id,
      action: "order",
      query: {
        where: this.listSearchWhere || initWhere
      },
      body: { action }
    });

    this.$Message.success("排序成功");
    this.getList();
  }
}
</script>

<style lang="scss" src="./style.scss"></style>
